import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { vendorOrdersInitialState } from './interfaces';
import { IVendorOrdersData } from '../../../types/vendorDashboard/IVendorOrders';
import { ISearchOrdersSettingsData } from '../../../types/vendorDashboard/ISearchOrdersSettingsData';

export const vendorOrdersReducer = createSlice({
  name: 'vendorOrders',
  initialState: vendorOrdersInitialState,
  reducers: {
    setVendorOrdersDataAction: (state, action: PayloadAction<IVendorOrdersData>) => {
      state.orders = action.payload;
    },
    setSearchOrderSettingsAction: (state, action: PayloadAction<ISearchOrdersSettingsData>) => {
      state.searchSettings = action.payload;
    },
    setVendorOrdersFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.ordersFetchStatus = action.payload;
    },
    setVendorOrdersErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.ordersError = action.payload;
    },
  },
});
export const {
  setVendorOrdersDataAction,
  setSearchOrderSettingsAction,
  setVendorOrdersFetchStatusAction,
  setVendorOrdersErrorAction,
} = vendorOrdersReducer.actions;
